<template>
  <div>
    <canvas
      :id="cid"
      :canvas-id="cid"
      :width="size * 2"
      :height="size * 2"
      :style="`position: absolute; left: -9999px; top: -9999px;`"
    />
    <img
      v-if="qrCodeSrc"
      :src="qrCodeSrc"
      :style="`width: ${size}px; height: ${size}px;`"
      mode="aspectFit"
    />
  </div>
</template>
<script>
import UQRCode from '@uqrcode/js';
export default {
  props: {
    cid: {
      type: String,
      default: 'barcode',
    },
    value: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 250,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      qrCodeSrc: '', // 存储生成的 base64 图片
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.draw();
          });
        }
      },
      immediate: false,
    },
  },
  mounted() {
    this.draw();
  },
  methods: {
    cleanup() {
      if (this.qr) {
        this.qr = null;
      }
      if (this.canvasContext) {
        this.canvasContext = null;
      }
    },
    draw() {
      if (!this.qr) {
        // 获取uQRCode实例
        const qr = new UQRCode();

        // 设置二维码内容
        qr.size = this.size * 2;
        // 获取canvas上下文
        this.canvas = document.getElementById(this.cid);
        this.canvasContext = this.canvas.getContext('2d'); // 如果是组件，this必须传入
        // 设置uQRCode实例的canvas上下文
        qr.canvasContext = this.canvasContext;
        // 调用制作二维码方法
        qr.errorCorrectLevel = 1
        this.qr = qr;
      }
      this.qr.data = this.value;
      // 设置二维码大小，必须与canvas设置的宽高一致
      this.qr.make();
      // 调用绘制方法将二维码图案绘制到canvas上
      this.qr.drawCanvas().then(() => {
        const dataUrl = this.canvas.toDataURL('image/png')
        this.qrCodeSrc = dataUrl
      });
    },
  },
};
</script>
